import React from 'react';
import { WebUiButton } from 'src/modules/web-ui/components/button';
import { WebUiInput } from 'src/modules/web-ui/components/input';

import { type DhcpSubnet } from './types';

export default function SubnetsSection({
  readonly,
  subnets,
  setSubnets,
  onUpdateSubnet,
  onRemoveSubnet,
}: {
  readonly: boolean;
  subnets: DhcpSubnet[];
  setSubnets: React.Dispatch<React.SetStateAction<DhcpSubnet[]>>;
  onUpdateSubnet: (subnet: DhcpSubnet) => void;
  onRemoveSubnet: (subnet: DhcpSubnet) => void;
}) {
  return (
    <div className="flex flex-col gap-2">
      <h4 className="font-bold">DHCP Server Settings for IP Networks</h4>
      {subnets.map((subnet, idx) => (
        <div
          key={`${subnet.ip}-${subnet.mask}-${idx}`}
          className="flex flex-col gap-2"
        >
          <table className="webui-table w-full">
            <thead>
              <tr className="webui-table-row-head">
                <th>Setting</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr className="webui-table-row-content">
                <td>Network Address</td>
                <td>{subnet.ip}</td>
              </tr>
              <tr className="webui-table-row-content">
                <td>Network Mask</td>
                <td>{subnet.mask}</td>
              </tr>
              <tr className="webui-table-row-content">
                <td>Leasetime (s)</td>
                <td>
                  <WebUiInput
                    inputSize="sm"
                    disabled={readonly}
                    type="number"
                    value={subnet.leasetime}
                    onChange={(e) =>
                      setSubnets((prev) =>
                        prev.map((x, i) =>
                          i === idx
                            ? { ...x, leasetime: Number(e.target.value) }
                            : x,
                        ),
                      )
                    }
                  />
                </td>
              </tr>
              <tr className="webui-table-row-content">
                <td>Pool</td>
                <td>
                  <div className="flex flex-row gap-1">
                    <div className="flex items-center gap-1">
                      <label>enable</label>
                      <WebUiInput
                        inputSize="sm"
                        type="checkbox"
                        disabled={readonly}
                      />
                    </div>
                    <WebUiInput
                      inputSize="sm"
                      disabled={readonly}
                      value={subnet.pool_start}
                      onChange={(e) =>
                        setSubnets((prev) =>
                          prev.map((x, i) =>
                            i === idx
                              ? { ...x, pool_start: e.target.value }
                              : x,
                          ),
                        )
                      }
                    />{' '}
                    -{' '}
                    <WebUiInput
                      inputSize="sm"
                      disabled={readonly}
                      value={subnet.pool_end}
                      onChange={(e) =>
                        setSubnets((prev) =>
                          prev.map((x, i) =>
                            i === idx ? { ...x, pool_end: e.target.value } : x,
                          ),
                        )
                      }
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="mt-2 flex flex-row gap-2">
            <WebUiButton
              disabled={readonly}
              onClick={() => onUpdateSubnet(subnet)}
            >
              Update Subnet
            </WebUiButton>
            <WebUiButton
              disabled={readonly}
              onClick={() => onRemoveSubnet(subnet)}
            >
              Remove Subnet
            </WebUiButton>
          </div>
        </div>
      ))}
      {!subnets.length ? (
        <div className="text-[12px]">No subnets configured.</div>
      ) : null}
    </div>
  );
}
